import { useNotesContext } from '../contexts/NotesContext';

/**
 * Given `anchorId`, looks up and returns `{anchorType, anchorName}`.
 */
const useAnchorData = (anchorId) => {
  const { anchorDataById } = useNotesContext();
  return anchorDataById[anchorId] ?? {};
};

export default useAnchorData;
